import { render } from "./adjustHedge.vue?vue&type=template&id=27f81280&scoped=true"
import script from "./adjustHedge.vue?vue&type=script&lang=js"
export * from "./adjustHedge.vue?vue&type=script&lang=js"

import "./adjustHedge.vue?vue&type=style&index=0&id=27f81280&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27f81280"]])

export default __exports__